import { createApi, fetchBaseQuery, retry } from '@reduxjs/toolkit/query/react'
import { HomepageUSPResponse } from '@/src/types/homepage'

// Dynamic URL based on locale: use local file in development, hosted URL in production
const getUSPUrl = (locale: string) => {
    const fileName = `homepage-usp-${locale}.json`
    return `https://ui.cltp.co/json/${fileName}`
}

const baseQueryWithRetry = retry(
    fetchBaseQuery({
        baseUrl: '',
        prepareHeaders: headers => {
            headers.set('Accept', 'application/json')
            headers.set('Content-Type', 'application/json')
            headers.set('Cache-Control', 'no-cache')
            return headers
        }
    }),
    {
        maxRetries: 0
    }
)

export const homepageUSPApi = createApi({
    reducerPath: 'homepageUSPApi',
    baseQuery: baseQueryWithRetry,
    tagTypes: ['HomepageUSP'],
    endpoints: builder => ({
        getHomepageUSP: builder.query<HomepageUSPResponse, string>({
            query: (locale: string) => ({
                url: getUSPUrl(locale),
                method: 'GET'
            }),
            providesTags: ['HomepageUSP']
        })
    })
})

export const { useGetHomepageUSPQuery } = homepageUSPApi
export default homepageUSPApi
